<div class="h-full flex flex-column align-items-center justify-content-around">

  @if (appService.isPortrait() || !appService.isPhone) {
    <div>
      <img height="200" src="assets/images/images/Logo-Biifor.png" />
    </div>
  }

  <!-- Validation en cours : sans cet état, l'écran reste nu le temps de l'appel -->
  @if (loading) {
    <div class="flex flex-column align-items-center gap-3">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
      <div class="text-lg">Validation de votre nouvelle adresse email…</div>
    </div>
  }

  <!-- Adresse validée -->
  @if (!loading && !refusal) {
    <div class="col-10 lg:col-6 dxl:col-5 txl:col-4 text-lg line-height-3 text-center">
      {{ message }}
    </div>
  }

  <!-- Refus : le motif vient du serveur, la sortie est le profil pour les cinq (#1124) -->
  @if (refusal) {
    <div class="col-10 lg:col-6 dxl:col-5 txl:col-4">
      <app-message severity="error" icon="fa-solid fa-link-slash" [title]="refusal.shortText"
        [messages]="[refusal.longText]" [primaryAction]="profileAction"
        [secondaryActions]="loginActions"></app-message>
    </div>
  }

</div>
